import { useEffect } from "react";
import { useMatches } from "react-router-dom";

export const usePageTitle = () => {
  const matches = useMatches();

  useEffect(() => {
    const { handle, params } = matches[matches.length - 1];

    const page = handle?.title || "";
    const tab = params?.tab
      ? params.tab.charAt(0).toUpperCase() + params.tab.slice(1)
      : "";

    let title = "MiBuild";

    if (page && tab) {
      title = `${page} - ${tab} | MiBuild`;
    } else if (page) {
      title = `${page} | MiBuild`;
    }

    document.title = title;
  }, [matches]);
};
